import React, { Component } from 'react'
import './Home.css'
import logo from '../assets/img/logo.png';

export default class Home extends Component {
  render() {
    return (
      <div>
        <section id="hero" className="d-flex align-items-center myh">
          <div className="container">
            <div className="row valign">
              <div className="col-sm-12">
                <img className="img-fluid brain" src={ logo } alt="Brain" />
              </div>  
              <div className="col-sm-12 col-md-8 offset-md-2 text-center panel">
                <h2>
                  Yebo! Who Wants To Be A Billionaire?!
                </h2>
                <p>
                  I know you're my biggest fan! Prove it to everyone and win cool prizes!
                </p>
                <button onClick={() => this.props.onSelectQuiz("lyrics")} className="btn btn-lg btn-secondary waves-effect waves-light">Play Now!</button>
                {/* <button onClick={() => this.props.onSelectQuiz("video")} className="btn btn-lg btn-secondary waves-effect waves-light">Video Trivia</button> */}
                {/* &nbsp; */}
                <a href="/high-scores" className="btn btn-lg btn-secondary waves-effect waves-light">Hi Scores!</a>
              </div>
            </div>
          </div>

        </section>
      </div>
    )
  }
}
